// Version check utility to detect when a new version is deployed
export const APP_VERSION = process.env.REACT_APP_VERSION || 'unknown';

const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

export const checkVersion = async (): Promise<boolean> => {
  try {
    const response = await fetch('/index.html', {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
      },
    });

    const html = await response.text();
    const versionMatch = html.match(/<meta name="version" content="([^"]+)"/);

    if (versionMatch && versionMatch[1] !== APP_VERSION) {
      return true; // New version available
    }

    return false;
  } catch (error) {
    console.error('Error checking version:', error);
    return false;
  }
};

export const startVersionCheck = (onNewVersion: () => void) => {
  const intervalId = setInterval(async () => {
    const hasNewVersion = await checkVersion();
    if (hasNewVersion) {
      onNewVersion();
      clearInterval(intervalId);
    }
  }, VERSION_CHECK_INTERVAL);

  return () => clearInterval(intervalId);
};
